// extracted by mini-css-extract-plugin
export default {"form":"FormComprador_form__njXb6"};